import { render, staticRenderFns } from "./payMentModal2.vue?vue&type=template&id=04a4a734&"
import script from "./payMentModal2.vue?vue&type=script&lang=js&"
export * from "./payMentModal2.vue?vue&type=script&lang=js&"
import style0 from "./payMentModal2.vue?vue&type=style&index=0&id=04a4a734&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports